module.exports = __webpack_public_path__ + "ecosystem-token-centered.398b64df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/ecosystem-token-centered.png
// module id = 1522
// module chunks = 0